<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <div class="pa-6">
          <div class="grid_btn_size">
            <v-btn
              x-large
              class="text-center grad-success-bg white--text btn_size ml-2"
              to="/stock/storage/poreceipt"
            >
              เพิ่มสินค้าเข้าคลังจากใบสั่งซื้อ
            </v-btn>
            <v-btn
              x-large
              class="text-center grad-warning-bg white--text btn_size ml-2"
              to="/stock/storage/prreceipt"
            >
              เพิ่มสินค้าเข้าคลังจากใบเสร็จ
            </v-btn>
            <v-btn
              x-large
              class="text-center grad-cancel-bg white--text btn_size ml-2"
              to="/stock/storage/cnreceipt"
            >
              เพิ่มสินค้าเข้าคลังจากใบ CN
            </v-btn>
          </div>
        </div>
        <div class="ma-4">
          <v-card-title> ประวัติการนำเข้าสินค้า </v-card-title>
          <v-card-title>
            <v-text-field
              v-model="search"
              color="#86bc3a"
              append-icon="mdi-magnify"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <!-- <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :items-per-page="perPage" :search="search" mobile-breakpoint="0"> -->
          <v-data-table
            :headers="headers"
            :items="data_list"
            :footer-props="footer_Props"
            :search="search"
            :custom-filter="customFilter"
            :items-per-page="perPage"
            mobile-breakpoint="0"
          >
            <!-- <template v-slot:item="dataDetail"> -->
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.receipt_no }}</td>
                <td>{{ dataDetail.item.doc_number }}</td>
                <td>{{ diffDate_TH(dataDetail.item.receipt_date) }}</td>
                <td>{{ diffDate_FromISO(dataDetail.item.created_at) }}</td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>{{ dataDetail.item.import_type_name }}</td>
                <td>
                  <div v-if="dataDetail.item.total !== null">
                    {{ format_price(dataDetail.item.total) }}
                  </div>
                  <div v-else>-</div>
                </td>
                <td>
                  <div v-if="dataDetail.item.user_name !== null">
                    {{ dataDetail.item.user_name }}
                  </div>
                  <div v-else>-</div>
                </td>
                <td class="pa-3">
                  <div v-if="dataDetail.item.import_type === 1">
                    <!-- {{ dataDetail }} -->
                    <v-btn
                      small
                      height="42"
                      @click="
                        po_detail(dataDetail.item.po_id, dataDetail.item.id)
                      "
                      class="grad-success-bg white--text mr-1 mb-1"
                      title="ดูรายละเอียด"
                    >
                      <v-icon>mdi-magnify</v-icon>PO
                    </v-btn>
                    <v-btn
                      small
                      height="42"
                      @click="
                        po_edit(dataDetail.item.po_id, dataDetail.item.id)
                      "
                      class="grad-warning-bg white--text mr-1 mb-1"
                      title="แก้ไขข้อมูล"
                    >
                      <v-icon>mdi-note-edit-outline</v-icon>PO
                    </v-btn>
                  </div>
                  <div v-else-if="dataDetail.item.import_type === 2">
                    <v-btn
                      small
                      height="42"
                      @click="pr_detail(dataDetail.item.id)"
                      class="grad-success-bg white--text mr-1 mb-1"
                      title="ดูรายละเอียด"
                    >
                      <v-icon>mdi-magnify</v-icon>PR
                    </v-btn>
                    <v-btn
                      small
                      height="42"
                      @click="pr_edit(dataDetail.item.id)"
                      class="grad-warning-bg white--text mr-1 mb-1"
                      title="แก้ไขข้อมูล"
                    >
                      <v-icon>mdi-note-edit-outline</v-icon>PR
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn
                      small
                      height="42"
                      @click="cn_detail(dataDetail.item.id)"
                      class="grad-success-bg white--text mr-1 mb-1"
                      title="ดูรายละเอียด"
                    >
                      <v-icon>mdi-magnify</v-icon>CN
                    </v-btn>
                    <v-btn
                      small
                      height="42"
                      @click="cn_edit(dataDetail.item.id)"
                      class="grad-warning-bg white--text mr-1 mb-1"
                      title="แก้ไขข้อมูล"
                    >
                      <v-icon>mdi-note-edit-outline</v-icon>CN
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { diffDateTH, diffDateFromISO, formatPrice } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "AddProduct_ToStock",
  data() {
    return {
      loading_page: false,
      search: null,
      perPage: 15,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "เลขที่ใบเสร็จ",
          value: "receipt_no",
          fixed: true,
          width: "160px",
        },
        {
          text: "เลขที่เอกสาร",
          value: "doc_number",
          fixed: true,
          width: "170px",
        },
        {
          text: "วันที่",
          value: "receipt_date",
          fixed: true,
          width: "150px",
        },
        {
          text: "วันที่บันทึก",
          value: "created_at",
          fixed: true,
          width: "150px",
        },
        {
          text: "ชื่อบริษัท",
          value: "supplier_name",
          fixed: true,
          width: "300px",
        },
        {
          text: "การนำเข้า",
          value: "import_type_name",
          fixed: true,
          width: "150px",
        },
        {
          text: "ยอดซื้อ",
          value: "total",
          fixed: true,
          width: "150px",
        },
        {
          text: "ผู้จัดทำ",
          value: "user_name",
          fixed: true,
          width: "180px",
        },
        {
          text: "จัดการ",
          value: "",
          sortable: false,
          fixed: true,
          width: "250px",
        },
      ],
      data_list: [],
    };
  },
  methods: {
    diffDate_TH: function (value) {
      return diffDateTH(value);
    },
    diffDate_FromISO: function (value) {
      return diffDateFromISO(value);
    },
    format_price: function (value) {
      return formatPrice(value);
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const searchText = search.toLowerCase().trim();

      // ค้นหาเลขที่ใบเสร็จ
      if (item.receipt_no && item.receipt_no.toString().toLowerCase().includes(searchText)) {
        return true;
      }

      // ค้นหาเลขที่เอกสาร
      if (item.doc_number && item.doc_number.toString().toLowerCase().includes(searchText)) {
        return true;
      }

      // ค้นหาวันที่ (receipt_date) - raw และ formatted
      if (item.receipt_date) {
        const dateRaw = item.receipt_date.toString().toLowerCase();
        if (dateRaw.includes(searchText)) {
          return true;
        }
        const dateFormatted = this.diffDate_TH(item.receipt_date).toLowerCase();
        if (dateFormatted.includes(searchText)) {
          return true;
        }
      }

      // ค้นหาวันที่บันทึก (created_at) - raw และ formatted
      if (item.created_at) {
        const dateRaw = item.created_at.toString().toLowerCase();
        if (dateRaw.includes(searchText)) {
          return true;
        }
        const dateFormatted = this.diffDate_FromISO(item.created_at).toLowerCase();
        if (dateFormatted.includes(searchText)) {
          return true;
        }
      }

      // ค้นหาชื่อบริษัท
      if (item.supplier_name && item.supplier_name.toLowerCase().includes(searchText)) {
        return true;
      }

      // ค้นหาการนำเข้า
      if (item.import_type_name && item.import_type_name.toLowerCase().includes(searchText)) {
        return true;
      }

      // ค้นหายอดซื้อ - raw, formatted, และตัวเลข
      if (item.total !== null && item.total !== undefined) {
        const totalRaw = item.total.toString().toLowerCase();
        const totalFormatted = this.format_price(item.total).toLowerCase().replace(/,/g, '');
        const totalNumber = parseFloat(item.total).toString();
        if (totalRaw.includes(searchText) || totalFormatted.includes(searchText) || totalNumber.includes(searchText)) {
          return true;
        }
      }

      // ค้นหาผู้จัดทำ
      if (item.user_name && item.user_name.toLowerCase().includes(searchText)) {
        return true;
      }

      return false;
    },
    get_data() {
      this.loading_page = true;
      // ดึงข้อมูลทั้งหมดมาเพื่อให้ client-side filter ได้ (ดึงมาเยอะๆ เพื่อให้ครอบคลุม)
      HTTP.post(
        `/imports/all?page=1&size=10000&search=`
      ).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false;
          this.data_list = res.data.object;
        }
      });
    },
    po_detail(id, import_id) {
      const routeData = this.$router.resolve({
        path: "/stock/storage/podetail/" + id + "/" + import_id,
      });
      window.open(routeData.href, "_blank");
    },
    po_edit(id, import_id) {
      const routeData = this.$router.resolve({
        path: "/stock/storage/poedit/" + id + "/" + import_id,
      });
      window.open(routeData.href, "_blank");
    },
    pr_detail(id) {
      const routeData = this.$router.resolve({
        path: "/stock/storage/prdetail/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    pr_edit(id) {
      const routeData = this.$router.resolve({
        path: "/stock/storage/predit/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    cn_detail(id) {
      const routeData = this.$router.resolve({
        path: "/stock/storage/cndetail/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    cn_edit(id) {
      const routeData = this.$router.resolve({
        path: "/stock/storage/cnedit/" + id,
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.grid_btn_size {
  display: grid;
  grid-template-columns: 33% 34% 33%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 768px) {
  .grid_btn_size {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 500px) {
  .grid_btn_size {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
